export enum WebhookEndpointsActionType {
  GetWebhookEndpoints = 'webhookEndpoints/getWebhookEndpoints',
  GetWebhookEndpoint = 'webhookEndpoints/getWebhookEndpoint',
  CreateWebhookEndpoint = 'webhookEndpoints/createWebhookEndpoint',
  UpdateWebhookEndpoint = 'webhookEndpoints/updateWebhookEndpoint',
  DeleteWebhookEndpoint = 'webhookEndpoints/deleteWebhookEndpoint',
  GenerateNewWebhookEndpointSecret = 'webhookEndpoints/generateNewWebhookEndpointSecret',
  SaveWebhookEndpoints = 'webhookEndpoints/saveWebhookEndpoints',
}
